import { useState, useEffect } from 'react';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

export const useProjectMembers = (projectId) => {
    const [members, setMembers] = useState({});
    const [memberDetails, setMemberDetails] = useState({});
    const [error, setError] = useState('');

    useEffect(() => {
        if (!projectId) return;

        const unsubscribe = onSnapshot(
            doc(db, 'projects', projectId),
            async (projectDoc) => {
                if (!projectDoc.exists()) {
                    setError('Project not found');
                    return;
                }

                const projectData = projectDoc.data();
                const projectMembers = projectData.members || {};
                setMembers(projectMembers);

                if (Object.keys(projectMembers).length > 0) {
                    try {
                        const memberPromises = Object.keys(projectMembers).map(uid =>
                            getDoc(doc(db, 'users', uid))
                        );

                        const memberDocs = await Promise.all(memberPromises);
                        const details = {};
                        memberDocs.forEach(doc => {
                            if (doc.exists()) {
                                details[doc.id] = doc.data();
                            }
                        });
                        setMemberDetails(details);
                    } catch (memberError) {
                        console.error('Error fetching member details:', memberError);
                        setError('Error loading member details');
                    }
                }
            },
            (error) => {
                console.error('Error fetching members:', error);
                setError('Error loading members');
            }
        );

        return () => unsubscribe();
    }, [projectId]);

    return { members, memberDetails, error };
};